<hr [id]="htmlId()" [style.display]="isVisible() ? 'block' : 'none'" />
